import { createSlice } from "@reduxjs/toolkit";

const reducerSlice = createSlice({
  name: "All-Order",
  initialState: {
    list: [],
    search: "",
    sort: "",
    startDateFilter: "",
    endDateFilter: "",
    hasMoreItems: true,
    loadingData: false,
    showInvoiceModal: false,
    invoiceDetail: {},
    showTrackingModal: false,
    trackingDetail: {},
    isEmptyList: false,
    page: 0,
    modalComplete: false,
    modalCancel: false,
    dataComplete: "",
    dataCancel:"",
    loadingButton: false,
    disabledSetcomplete: false,
    disabledSetcancel: false,
  },
  reducers: {
    setList: (state, action) => {
      state.list = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setStartDateFilter: (state, action) => {
      state.startDateFilter = action.payload;
    },
    setEndDateFilter: (state, action) => {
      state.endDateFilter = action.payload;
    },
    setHasMoreItems: (state, action) => {
      state.hasMoreItems = action.payload;
    },
    setLoadingData: (state, action) => {
      state.loadingData = action.payload;
    },
    setShowInvoiceModal: (state, action) => {
      state.showInvoiceModal = action.payload;
    },
    setInvoiceDetail: (state, action) => {
      state.invoiceDetail = action.payload;
    },
    setShowTrackingModal: (state, action) => {
      state.showTrackingModal = action.payload;
    },
    setTrackingDetail: (state, action) => {
      state.trackingDetail = action.payload;
    },
    setIsEmptyList: (state, action) => {
      state.isEmptyList = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setModalComplete: (state, action) => {
      state.modalComplete = action.payload;
    },
    setModalCancel: (state, action) => {
      state.modalCancel = action.payload;
    },
    setDataComplete: (state, action) => {
      state.dataComplete = action.payload;
    },
    setDataCancel: (state, action) => {
      state.dataCancel = action.payload;
    },
    setLoadingButton: (state, action) => {
      state.loadingButton = action.payload;
    },
    setDisabledSetcomplete: (state, action) => {
      state.disabledSetcomplete = action.payload;
    },
    setDisabledSetcancel: (state, action) => {
      state.disabledSetcancel = action.payload;
    },
  },
});

export const {
  setList,
  setSearch,
  setSort,
  setStartDateFilter,
  setEndDateFilter,
  setHasMoreItems,
  setLoadingData,
  setShowInvoiceModal,
  setInvoiceDetail,
  setShowTrackingModal,
  setTrackingDetail,
  setIsEmptyList,
  setPage,
  setModalComplete,
  setModalCancel,
  setDataComplete,
  setDataCancel,
  setLoadingButton,
  setDisabledSetcomplete,
  setDisabledSetcancel,
} = reducerSlice.actions;
export default reducerSlice;
